import { useState, useEffect } from "react";
export var useMediaQuery = function (mediaQuery) {
    var mobileMediaQuery = window.matchMedia(mediaQuery);
    var _a = useState(mobileMediaQuery.matches), isMatch = _a[0], setIsMatch = _a[1];
    useEffect(function () {
        var matchMediaListener = function (e) { setIsMatch(e.matches); };
        try {
            mobileMediaQuery.addEventListener('change', matchMediaListener);
        }
        catch (e) {
            mobileMediaQuery.addListener(matchMediaListener);
        }
        return function () {
            try {
                mobileMediaQuery.removeEventListener('change', matchMediaListener);
            }
            catch (e) {
                mobileMediaQuery.removeListener(matchMediaListener);
            }
        };
    }, []);
    return isMatch;
};
